import { render, staticRenderFns } from "./page-md-tally.vue?vue&type=template&id=42729a9a&"
import script from "./page-md-tally.vue?vue&type=script&lang=ts&"
export * from "./page-md-tally.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./page-md-tally.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports